import { Component, OnInit, inject } from '@angular/core';
import { GenericPageComponent } from '@shared/modules/general-commons/components/generic-page/generic-page.component';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'stx-auth-container',
  imports: [GenericPageComponent, TranslateModule],
  templateUrl: 'auth-container.component.html'
})
export class AuthContainerComponent implements OnInit {
  private router = inject(Router);

  ngOnInit() {
    this.router.navigateByUrl('/');
  }
}
